import React from 'react';

import useActivePage from '../../../../r/hooks/active-page';
import { files } from '../../../libs/assets';
import { FooterWrapper } from './styled';

const applicablePages = ['Features'];

const lightThemePages = [
	'/registration-forms',
	'/data-collection',
	'/booking-forms',
	'/survey-forms',
	'/quiz-maker',
	'/workflows',
	'/lp-two',
	'/lp'
];

const socialIcons = [
	{ href: 'https://www.facebook.com/formplusapp', icon: '#icon-social-facebook' },
	{ href: 'https://www.linkedin.com/company/formplus', icon: '#icon-linkedin' },
	{ href: 'https://www.instagram.com/formplusapp/', icon: '#icon-instagram' },
	{ href: 'https://twitter.com/formplusapp', icon: '#icon-twitter' }
];

const Footer = () => {
	const theme = lightThemePages.includes(location.pathname) ? 'light' : 'dark';
	const logo = files[theme === 'light' ? 'logoBlack' : 'logoWhite'];
	const currentYear = new Date().getFullYear();
	const activePage = useActivePage();
	
	if (!applicablePages.includes(activePage.name)) return null;
	
	return (
		<FooterWrapper className={theme}>
			<div className="top">
				<div className="links">
					<div className="section">
						<h2>PRODUCT PAGES</h2>

						<ul>
							<li><a href="/application-forms">Application Forms</a></li>
							<li><a href="/booking-forms">Booking Forms</a></li>
							<li><a href="/payment-forms">Payment Forms</a></li>
							<li><a href="/survey-forms">Survey Forms</a></li>
							<li><a href="/order-forms">Order Forms</a></li>
							<li><a href="/quiz-maker">Quiz Maker</a></li>
							<li><a href="/registration-forms">Registration Forms</a></li>
							{/* <li><a href="/approval-workflow-forms">Approvals and Workflows</a></li> */}
						</ul>
					</div>

					<div className="section">
						<h2>QUICK LINKS</h2>

						<ul>
							<li><a href="/e/auth/sign-up">Sign up</a></li>
							<li><a href="/e/auth">Log in</a></li>
							<li><a href="/pricing">Pricing</a></li>
							<li><a href="https://help.formpl.us/s/">Support</a></li>
							<li><a href="/form/926396118">Contact Us</a></li>
						</ul>
					</div>

					<div className="section">
						<h2>RESOURCES</h2>

						<ul>
							<li><a href="/templates">Templates</a></li>
							<li><a href="/case-studies">Customers</a></li>
							<li><a href="/convince-your-team">Convince your team</a></li>
							<li><a href="https://www.formpl.us/form/31606002" target="_blank" rel="noopener noreferrer">Enterprise Solutions</a></li>
							<li><a href="/sitemap">Sitemap</a></li>
						</ul>
					</div>
				</div>

				<div className="section brand">
					<div className="logo">
						<img src={logo} width="150" alt="FormPlus Logo" />
					</div>
						
					<div className="social-icons">
						{socialIcons.map(({ href, icon }) => (
							<a key={href} href={href} target="_blank">
								<svg><use xlinkHref={icon}></use></svg>
							</a>
						))}
					</div>
				</div>
			</div>

			<div className="bottom">
				<ul className="left">
					<li><a href="https://help.formpl.us/s/topic/0TO6g000000U09OGAS/faqs">FAQ</a></li>
					<li><a href="/terms-and-privacy#privacy">Privacy Policy</a></li>
					<li><a href="/terms-and-privacy">Terms &amp; Conditions</a></li>
				</ul>
				<div className="right">
					All Rights Reserved &copy; Formplus {currentYear}
				</div>
			</div>
		</FooterWrapper>
	);
};

export default Footer;